import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from './../../../../environments/environment';
import { UtilsService } from './../../../_services/utils.service';

@Injectable({
    providedIn: 'root'
})

export class PlayersService {
    constructor(private _http: Http, private http: HttpClient, private _utilsService: UtilsService) {
    }

    getTeamPlayers(playerAPIUrl): Observable<any> {
        return this._utilsService.getRequest(playerAPIUrl);
    }

    getTeamList(teamAPIUrl): Observable<any> {
        return this._utilsService.getRequest(teamAPIUrl);
    }

    rosterPosition(teamAPIUrl): Observable<any> {
        return this._utilsService.getRequest(teamAPIUrl);
    }

    leaguePositionSettings(teamAPIUrl): Observable<any> {
        return this._utilsService.getRequest(teamAPIUrl);
    }

    defaultRanking(league_id, league_member_id): Observable<any> {
        const scorePost = { 'league_id': league_id, 'league_mem_id': league_member_id };
        return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/league/removeRankings', scorePost, null, 'content-type-json');
    }

    private handleErrorPost<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
